import React, { Component } from "react";
import { Card, CardContent } from "../ui/card";
import { userService } from "../../_services";

/**
 * Affiliate ID Total Component
 * Displays Total Referrals and Referral Commission
 * Modernized with Shadcn Card component
 */
class Affiliate_id_total extends Component {
    constructor(props) {
        super(props);
        this.state = {
            referralCount: 'N/A',
            RefBonus: ''
        };
    }

    componentDidMount() {
        try {
            let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            this.GetUserReferalBonus(Usermeta_Data.split(':')[0]);
            
            var uniqueNames = [];
            for (var i = 0; i < this.props.Referrals.length; i++) {
                if (uniqueNames.indexOf(this.props.Referrals[i].userName) === -1) {
                    uniqueNames.push(this.props.Referrals[i].userName);
                }
            }
            this.setState({ referralCount: uniqueNames.length });
        } catch (error) {
            console.error('Error in componentDidMount:', error);
        }
    }

    GetUserReferalBonus(UserId) {
        try {
            userService.GetUserReferalBonus(UserId)
                .then(
                    apidata => {
                        let ReferralBonusTotal = 0;
                        if (apidata.length > 0) {
                            ReferralBonusTotal = apidata[0].subDistComm.toFixed(2);
                        }
                        this.setState({ RefBonus: ReferralBonusTotal })
                    });
        } catch (error) {
            console.error('Error fetching referral bonus:', error);
        }
    }

    render() {
        return (
            <Card>
                <CardContent className="p-0">
                    <div className="grid grid-cols-2 divide-x divide-border">
                        {/* Total Referrals */}
                        <div className="p-6 text-center">
                            <p className="text-sm text-muted-foreground mb-2">Total Referrals</p>
                            <span className="text-3xl font-bold text-foreground">
                                {this.state.referralCount}
                            </span>
                        </div>
                        
                        {/* Referral Commission */}
                        <div className="p-6 text-center">
                            <p className="text-sm text-muted-foreground mb-2">Referral Commission</p>
                            <span className="text-3xl font-bold text-foreground">
                                ${this.state.RefBonus}
                            </span>
                        </div>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

export default Affiliate_id_total;
